import { languageSchema } from "./languageSchema";

export const getAllTicketsSchema = {
  querystring: {
    type: "object",
    properties: {
      eventId: { type: "number" },
      page: { type: "number" },
      limit: { type: "number" },
      ...languageSchema.properties,
    },
    required: ["eventId"],
  },
};

export const getNewTicketByIdSchema = {
  params: {
    type: "object",
    properties: {
      ticketId: { type: "number" },
    },
    required: ["ticketId"],
  },
};

export const createNewTicketSchema = {
  body: {
    type: "object",
    properties: {
      eventId: { type: "number" },
      userData: {
        type: "object",
        properties: {
          firstName: { type: ["string", "null"] },
          lastName: { type: ["string", "null"] },
          email: { type: ["string", "null"] },
        },
      },
    },
    required: ["eventId"],
  },
};

export const updateNewTicketSchema = {
  params: {
    type: "object",
    properties: {
      ticketId: { type: "number" },
    },
    required: ["ticketId"],
  },
  body: {
    type: "object",
    properties: {
      firstName: { type: ["string", "null"] },
      lastName: { type: ["string", "null"] },
      email: { type: ["string", "null"] },
    },
  },
};

export const deleteNewTicketSchema = {
  params: {
    type: "object",
    properties: {
      ticketId: { type: "number" },
    },
    required: ["ticketId"],
  },
};

export const web_createNewTicketSchema = {
  type: "object",
  properties: {
    eventId: { type: "number" },
    email: {
      anyOf: [{ type: "null" }, { type: "string", format: "email" }],
      errorMessage: "Invalid email format.",
    },
    firstName: { type: ["string", "null"] },
    lastName: { type: ["string", "null"] },
  },
};
